module.exports = __webpack_public_path__ + "static/media/icon_196.43cc45cb.svg";